import { StandingOfferStatus } from "@/gql/__generated__/graphql";
import { useMemo } from "react";
import { StandingOffer, StandingOfferTable } from "../types/subscriptions.type";

export function useStandingOfferTableData(
  standingOffers: StandingOffer[],
  filterCancelled: boolean
) {
  const data: StandingOfferTable[] = useMemo(
    () =>
      standingOffers
        .filter(
          (offer) =>
            filterCancelled || offer.status === StandingOfferStatus.Active
        )
        .map(convertStandingOfferToTableData),
    [filterCancelled, standingOffers]
  );

  return data;
}

function convertStandingOfferToTableData({
  id,
  app,
  createdAt,
  name,
  status,
  payment
}: StandingOffer): StandingOfferTable {
  return {
    id,
    appName: app.displayName,
    appImage: app.pictureUrl,
    createdAt,
    status,
    reference: name,
    monthlyPriceUSD: payment?.monthlyPriceUSD,
    trialDays: payment?.trialDays
  };
}
